import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { usePagesVisibility } from "../context/PagesContext";
import ConvergenLogo from "./ConvergenMark";

export default function Footer() {
  const { t } = useLang();
  const { pages } = usePagesVisibility();
  const year = new Date().getFullYear();
  const navLinks = [
    { to: "/", label: t.nav.home, key: "home" },
    { to: "/quienes-somos", label: t.nav.about, key: "about" },
    { to: "/servicios", label: t.nav.services, key: "services" },
    { to: "/iieas", label: t.nav.iieas, key: "iieas" },
    { to: "/synapse", label: t.nav.synapse, key: "synapse" },
    { to: "/insights", label: t.nav.insights, key: "insights" },
    { to: "/contacto", label: t.nav.contact, key: "contact" },
  ].filter((l) => pages[l.key] !== false);

  return (
    <footer className="border-t border-rule mt-24 bg-white" data-testid="site-footer">
      <div className="page-container py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <ConvergenLogo size={72} />
          <p className="mt-6 text-sm text-text-muted max-w-md leading-relaxed">{t.footer.tagline}</p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-[11px] font-mono tracking-[0.22em] uppercase text-cerulean mb-5">
            {t.footer.sections}
          </h4>
          <ul className="space-y-3 text-sm text-ink">
            {navLinks.map((l) => (
              <li key={l.to}><Link to={l.to} className="hover:text-cerulean transition-colors">{l.label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-[11px] font-mono tracking-[0.22em] uppercase text-cerulean mb-5">
            {t.footer.contact}
          </h4>
          <ul className="space-y-3 text-sm text-ink">
            <li>contacto@convergen.mx</li>
            <li>Ciudad de México, México</li>
            <li>
              <Link to="/contacto" className="hover:text-cerulean transition-colors underline underline-offset-4">
                {t.nav.cta} →
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-rule">
        <div className="page-container py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-text-muted">© {year} Convergen Consultoría. {t.footer.rights}</p>
          <div className="flex items-center gap-6 text-xs text-text-muted">
            <a
              href="/docs/aviso-de-privacidad-y-terminos.pdf"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="privacy-link"
              className="hover:text-cerulean transition-colors underline-offset-4 hover:underline"
            >
              {t.footer.privacy}
            </a>
            <Link to="/admin/login" data-testid="admin-link" className="hover:text-cerulean transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
